// extracted by mini-css-extract-plugin
export var connectionButton = "_av-1";
export var rightPanel = "_av-3";
export var stepDescription = "_av-2";
export var stepIcon = "_av-0";